import { Location } from 'react-router-dom';
import { ManifestTabKey, ManifestTabKeys } from './types';
import { ManifestHistoryTypes } from 'store/manifests/types';

export const getManifestActiveTabKey = (location: Location): ManifestTabKey => {
    const stateKey = (location.state as { activeTabKey?: ManifestTabKey })?.activeTabKey;

    if (stateKey && Object.values(ManifestTabKeys).includes(stateKey)) {
        return stateKey;
    }

    const segments = location.pathname.split('/');
    const potentialTabKey = segments[3] as ManifestTabKey;

    if (Object.values(ManifestTabKeys).includes(potentialTabKey)) {
        return potentialTabKey;
    }

    return ManifestTabKeys.OVERVIEW;
};

export const ManifestHistoryLabels: Record<ManifestHistoryTypes, string> = {
    [ManifestHistoryTypes.ARCHIVED]: 'Archived',
    [ManifestHistoryTypes.ASSIGNED_TO_OWNER]: 'Assigned to owner',
    [ManifestHistoryTypes.ASSIGNED_TO_TEAM]: 'Assigned to team',
    [ManifestHistoryTypes.CREATED]: 'Created',
    [ManifestHistoryTypes.JOB_ADDED]: 'Job added',
    [ManifestHistoryTypes.JOB_REMOVED]: 'Job removed',
    [ManifestHistoryTypes.UNARCHIVED]: 'Unarchived',
    [ManifestHistoryTypes.UPDATED]: 'Updated',
    [ManifestHistoryTypes.EXTERNAL_REFERENCES_UPDATED]: 'External references updated',
};

export const getManifestHistoryTypeLabel = (type: ManifestHistoryTypes): string => ManifestHistoryLabels[type];
